import type { Tenant } from '@shared/types/Tenant';

/**
 * Contexte tenant courant, partagé par toutes les couches.
 * Garantit l'isolation des données : aucune requête n'est exécutée sans tenant_id.
 */
export class TenantContext {
  private static instance: TenantContext | null = null;
  private currentTenant: Tenant | null = null;
  private listeners: ((tenant: Tenant | null) => void)[] = [];

  static getInstance(): TenantContext {
    if (!this.instance) this.instance = new TenantContext();
    return this.instance;
  }

  setTenant(tenant: Tenant | null): void {
    this.currentTenant = tenant;
    this.listeners.forEach((l) => l(tenant));
  }

  getTenant(): Tenant {
    if (!this.currentTenant) throw new TenantNotSetError();
    return this.currentTenant;
  }

  tryGetTenant(): Tenant | null {
    return this.currentTenant;
  }

  tenantId(): string {
    return this.getTenant().id;
  }

  onChange(listener: (tenant: Tenant | null) => void): () => void {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  }

  clear(): void {
    this.currentTenant = null;
    this.listeners.forEach((l) => l(null));
  }
}

export class TenantNotSetError extends Error {
  constructor() {
    super('Aucun tenant actif. Connectez-vous d abord.');
    this.name = 'TenantNotSetError';
  }
}

export class TenantMismatchError extends Error {
  constructor(expected: string, got: string) {
    super(`Accès cross-tenant interdit : attendu ${expected}, reçu ${got}`);
    this.name = 'TenantMismatchError';
  }
}
